import * as React from 'react'
import cx from 'classnames'
import styles from './QuestionContent.sass'
import Icon from 'components/Icon'
import { markdownToHtml } from 'utils/markdown-util'

interface QuestionTitleProps {
  title: string
  compact?: boolean
  onInfoClick?(): unknown
}

export function QuestionTitle({
  title,
  compact,
  onInfoClick,
}: QuestionTitleProps) {
  return (
    <h4 className={cx(styles.title)}>
      <span className={cx(styles.titleText, compact && styles.compactTitle)}>
        {title}
      </span>
      {onInfoClick && (
        <a className={styles.titleInfoToggle} onClick={onInfoClick}>
          <span className={styles.titleInfoIcon}>
            <Icon auto name="info" />
          </span>
        </a>
      )}
    </h4>
  )
}

interface QuestionDescriptionProps {
  description: string
  hidden?: boolean
}

export function QuestionDescription({
  description,
  hidden,
}: QuestionDescriptionProps) {
  const html = React.useMemo(() => markdownToHtml(description), [description])
  return hidden ? (
    <></>
  ) : (
    <div
      className={cx(styles.description, hidden && styles.hidden)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
